
import { Component, Vue, Prop, Watch, Emit, Model } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class Input extends Vue {
  @Prop() title!: string
  @Prop() desc!: string
  @Prop() placeholder!: string
  @Prop({ default: false }) showQrcode: boolean
  @Prop({ default: true }) codeDisabled: boolean
  @Prop({ default: 'string' }) valueType: string
  @Prop({ default: 0 }) maxLength!: number

  @Model('change', { type: String }) readonly value!: string

  get inputValue() {
    return this.value
  }

  set inputValue(val: string) {
    this.$emit('change', val)
  }

  isStartCountDown: boolean = false
  deadline: number = 60

  numberInput(target) {
    target.value = this.valueType === 'number' ? target.value.replace(/[^\d]/g, '') : target.value
  }

  handleSendSms() {
    if (this.codeDisabled) return

    this.$emit('on-qrcode', () => {
      this.toggleCountDown(true)
    })
  }

  toggleCountDown(loading: boolean = !this.isStartCountDown) {
    if (loading) {
      this.deadline = Date.now() + 1000 * 60
    }
    this.isStartCountDown = loading
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
